import { Pipe, PipeTransform } from '@angular/core';
import { marker as t } from '@biesbjerg/ngx-translate-extract-marker';

import { GenderEnum } from '@enums/gender.enum';

/*
 * Gets gender translation string
 * Usage:
 *  gender | genderPrefix
 * Example:
 *  // gender = 'Female'
 *  {{ gender | genderPrefix  }}
 *  fromats to: 'GENDER.FEMALE'
 */
@Pipe({
  name: 'genderPrefix',
})
export class GenderPrefixPipe implements PipeTransform {
  transform(value: string): string {
    let suffix = '';
    switch (value) {
      case GenderEnum.Female:
        suffix = t('GENDER.FEMALE');
        break;
      case GenderEnum.Male:
        suffix = t('GENDER.MALE');
        break;
      default:
        break;
    }

    return suffix;
  }
}
